import { Product } from "@/interfaces";
import { ProductItem } from "../../../components";
import * as S from "./styles";

export type ProductRowProps = {
  items?: Product[];
  defaultProductImageUrl?: string;
  coopEligible?: number;
  onItemClick?: (item: Product) => void;
};

const ProductRow: React.FC<ProductRowProps> = ({
  items = undefined,
  defaultProductImageUrl = undefined,
  coopEligible = undefined,
  onItemClick,
}) => {
  return Array.isArray(items) && items?.length ? (
    <S.ProductRowContainer>
      {items.map((item: Product, index: number) => (
        <ProductItem
          item={item}
          key={index}
          onItemClick={onItemClick}
          defaultProductImageUrl={defaultProductImageUrl}
          coopEligible={coopEligible}
        />
      ))}
    </S.ProductRowContainer>
  ) : null;
};

export default ProductRow;
